import { render, staticRenderFns } from "./CommonForm.vue?vue&type=template&id=4337d911&scoped=true"
import script from "./CommonForm.vue?vue&type=script&lang=js"
export * from "./CommonForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4337d911",
  null
  
)

export default component.exports